export enum ServiceStatuses {
    PREVIOUS = 0,
    TRIGGERED = 1,
    INPROGRESS = 2,
    COMPLETED = 3,
    PARTIALLLYCOMPLETED = 4,
    CANCELLED = 5
}

export const REQUIRED_INTERVAL_TIMEUNIT = 5;